module.exports = __webpack_public_path__ + "img/web-box.b07ab3e.svg";